import { useQuery } from "react-query";
import { getBooks } from "../../services/library/book";
import { key_books } from "../../utils/constants";
import { PagedRequestType } from "../../types/PagedResults";

export const useGetBooksQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        [key_books, JSON.stringify(data)],
        () => getBooks(data),
        options ? { ...options } : {}
    );
